import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { NavHeader, Page } from '../../../../../../components';
import { IconAddDevice } from '../../../../../../assets/status-screen-icons/icon-add-device';
import { ROUTES } from '../../../../../../routes/routes';
import { useBluetoothContext } from '../../context';
import './index.scss';

const DeviceAddBluetoothSuccess: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('device-add');
  const { deviceId } = useParams<{ deviceId: string }>();
  const { disconnect, releaseLock, returnToStartPage } = useBluetoothContext();

  useEffect(() => {
    releaseLock();
    disconnect();
  }, []);

  const goToDeviceSettings = () => navigate(ROUTES.DeviceSettings(deviceId));

  const goToChannels = () => navigate(ROUTES.Channel());

  return (
    <Page
      containerClassName="page__container--flex-height"
      className="device-add-success"
      header={<NavHeader onClick={goToChannels} />}
    >
      <div>
        <div className="icon-container">
          <IconAddDevice />
        </div>
        <div className="text-container">
          <p className="text-header">{t('addDeviceSuccess.header')}</p>
          <p>{t('addDeviceSuccess.message')}</p>
        </div>
      </div>
      <div className="success-buttons">
        <button className="button button--secondary" onClick={returnToStartPage}>
          {t('addDeviceSuccess.addNext')}
        </button>
        <button className="button" onClick={goToDeviceSettings}>
          {t('addDeviceSuccess.goToDeviceSettings')}
        </button>
        <button className="text-button" onClick={goToChannels}>
          {t('addDeviceSuccess.ready')}
        </button>
      </div>
    </Page>
  );
};

export default DeviceAddBluetoothSuccess;
